(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityType', activityType);

    function activityType() {
        return {
            restrict: 'E',
            scope: {
                inputData: '=',
                model: '=',
                onChange: '&?',
            },
            controller: activitiyTypeCtrl,
            controllerAs: 'vm',
            bindToController: true
        };
    }

    function activitiyTypeCtrl($compile, $scope, $element, HtmlHelper, ActivitiesInputService) {
        var vm = this,
            cloneElem = null;
        this.$onInit = function() {
            init();
        }

        function init() {
            $scope.$watch(watchType, onTypeChange);
            $scope.$on('$destroy', onDestroy);
        }

        function onDestroy() {
            switchOffElem();
        }

        function watchType() {
            return vm.inputData.options.type;
        }

        function onTypeChange() {
            switchOffElem();
            ActivitiesInputService.initDefaultModelField(vm.inputData);
            $element.html(generateHtmlContent());
            cloneElem = $compile($element.contents())($scope);
        }

        function generateHtmlContent() {
            var typeTag = 'activity-input-type-' + vm.inputData.options.type;
            var attrs = [
                {
                    name:'input-data',
                    value: 'vm.inputData'
                },
                {
                    name: 'model',
                    value: 'vm.model'
                },
                {
                    name: 'on-change',
                    value: 'vm.onChange({name: name, value: value})'
                }
            ];

            return HtmlHelper.generateHtmlTag(typeTag, attrs);
        }

        function switchOffElem() {
            if (cloneElem != null) {
                cloneElem.off();
            }
        }
    }
})();